import React from 'react';
import { defaultSchema } from '@atlaskit/adf-schema/schema-default';
import { JIRATransformer } from '@atlaskit/editor-jira-transformer';
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { ReactRenderer } from '@atlaskit/renderer';
export var HtmlExtension = function HtmlExtension(_ref) {
  var extensionId = _ref.extensionId,
    htmlContent = _ref.htmlContent;
  try {
    var jiraTransformer = new JIRATransformer(defaultSchema);
    var adfTransformer = new JSONTransformer();
    var pmNode = jiraTransformer.parse(htmlContent);
    var adf = adfTransformer.encode(pmNode);
    return /*#__PURE__*/React.createElement(ReactRenderer, {
      key: extensionId,
      document: adf
    });
  } catch (err) {
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  }
};